<template>
  <div class="page-wrapper">
    <div class="page-title">
      <CIcon name="cil-user-unfollow" /> Deleted Users
      <span class="page-title-badge" v-if="tableLength > 0">{{ tableLength }} records</span>
    </div>
        <CRow>            
            <CCol md="9" class="pad-r-0 pad-l-0">
                
                <CCard>
                    <CCardHeader class="text-center">
                        <CRow>
                            <CCol md="6">
                                <CInput 
                                    placeholder="Start typing phone number or name to serarch.."
                                    label="Deleted Users"
                                    v-model="searchText"
                                    v-on:input="getRecords()"
                                >
                                    <template #prepend>
                                        <CButton color="primary" @click="getRecords()">
                                        <CIcon name="cil-magnifying-glass"/> Search
                                        </CButton>
                                    </template>
                                </CInput>
                            </CCol>
                            <CCol md="3">
                                
                            </CCol>
                            <CCol md="3">
                                <div style="min-height : 25px; margin-top: 35px;"><pulse-loader :loading="loading" color="#2E7D32"></pulse-loader></div>
                            </CCol>
                        </CRow>                 
                    </CCardHeader>
                    <CCardBody >
                        <b-table 
                            hover
                            selectable
                            select-mode="single"
                            @row-selected="onSelectRow"
                            :items="items"
                            :fields="fields"
                            style="cursor : pointer"
                            id="reportTable"
                        >
                            <template v-slot:cell(user)="data">
                                <div>{{data.item.name}}</div>
                                <div class="small text-muted" v-if="data.item.email">
                                    {{data.item.email}}
                                </div>  
                                <div class="small text-muted">
                                    {{data.item.phone}}
                                </div>                               
                            </template>
                            <template v-slot:cell(assignedZone)="data">
                                <div>{{data.item.assignedZone ? data.item.assignedZone.name.toUpperCase() : ' - '}}</div>                        
                            </template>
                            <template v-slot:cell(activity)="data">
                                <div class="small text-muted">Registered</div>
                                <strong>{{data.item._createdAt | moment("from")}}</strong>                            
                            </template>
                            <template v-slot:cell(role)="data">
                                <div>{{data.item.role.toUpperCase()}}</div>
                                <div class="small text-muted">
                                    <CBadge color="danger" v-if="data.item._isAdminVerified == false">Not Verified</CBadge>
                                    <CBadge color="success" v-else>Verified</CBadge>
                                    <br>
                                    <CBadge color="warning" v-if="data.item._isRevoked == true">Revoked</CBadge>
                                    <br v-if="data.item._isAccountActive == false">
                                    <CBadge color="dark" v-if="data.item._isAccountActive == false">Disabled</CBadge>
                                </div>                              
                            </template>
                        </b-table>
                        <b-pagination 
                            align="center"
                            v-model="currentPage"
                            :total-rows="tableLength"
                            :per-page="perPage"
                            aria-controls="reportTable"
                        ></b-pagination>
                        
                    </CCardBody>                    
                </CCard>

            </CCol>
            <CCol md="3" class="pad-r-0">
                <CCard>
                    <CCardHeader class="text-center">
                        <strong>Preview</strong>
                    </CCardHeader>
                    <CCardBody v-if="preview.show">
                        <CRow>
                            <CCol sm="12" class="text-center">
                                <div><strong>{{preview.name}}</strong></div>
                                <div class="small text-muted">
                                    {{preview.email}} <br>
                                    {{preview.phone}} <br>
                                    {{roles[preview.role]}}
                                </div>  
                            </CCol>
                        </CRow>
                        <CRow class="mt-3">
                            <CCol sm="6" class="text-left">
                                Approve User
                            </CCol>
                            <CCol sm="6" class="text-right">
                                <toggle-button 
                                    v-if="preview._isAdminVerified"
                                    :value="true"
                                    :sync="true"
                                    v-model="preview._isAdminVerified"
                                    :disabled="true"/>
                                <toggle-button 
                                    v-else
                                    :value="true"
                                    v-model="preview._isAdminVerified"
                                    :tag="preview.userid"
                                    :sync="true"
                                    @change="approveUser"/>
                            </CCol>
                        </CRow>
                        <CRow class="mt-3">
                            <CCol sm="6" class="text-left">
                                Revoke User
                            </CCol>
                            <CCol sm="6" class="text-right">
                                <toggle-button 
                                    :value="preview._isRevoked"
                                    :sync="true"
                                    :tag="preview.userid"
                                    v-model="preview._isRevoked"
                                    @change="showRevokeModal"/>
                            </CCol>
                        </CRow>
                        <CRow class="mt-3">
                            <CCol sm="6" class="text-left">
                                Account Active
                            </CCol>
                            <CCol sm="6" class="text-right">
                                <toggle-button 
                                    :value="preview._isAccountActive"
                                    :sync="true"
                                    :tag="preview.userid"
                                    v-model="preview._isAccountActive"
                                    @change="toggleAccountStatus"/>
                            </CCol>
                        </CRow>
                        <CRow class="mt-3" @click="showRoleModal(true)" style="cursor : pointer">
                            <CCol sm="8" class="text-left">
                                Change Role
                            </CCol>
                            <CCol sm="4" class="text-right">
                                <CIcon name="cil-sync" size="lg"/>
                            </CCol>
                        </CRow>
                        <CRow class="mt-3" @click="showZoneModal(true)" style="cursor : pointer">
                            <CCol sm="8" class="text-left">
                                Change Zone
                            </CCol>
                            <CCol sm="4" class="text-right">
                                <CIcon name="cil-sync" size="lg"/>
                            </CCol>
                        </CRow>
                        
                        
                        
                    </CCardBody>
                    <CCardBody v-else>
                        <CRow>
                        <CCol sm="12" class="text-center">
                            <i>Click any user to show preview!</i>
                        </CCol>
                        </CRow>
                    </CCardBody>
                    <CCardFooter class="text-center" v-if="preview.show">
                        <CButton type="submit" size="sm" color="danger" style="float : left" @click="closePreview()"> Close </CButton>
                    </CCardFooter>
                </CCard>

            </CCol>
        </CRow>

        <CModal
            v-if="preview!= null"
            title="Revoke User"
            size="sm"
            :show.sync="modals.revoke"
        >
            <CForm>
                <CTextarea
                    label="Revoke for Revoking"
                    placeholder="Add a reason why you are doing this action. (Optional)"
                    horizontal
                    rows="9"
                    v-model="revoke.reason"
                />          
            </CForm>
            <template v-slot:footer>
                <CButton type="submit" size="sm" color="danger" style="float : left"    @click="showRevokeModal(null)">Cancel</CButton>
                <CButton type="submit" size="sm" color="success" style="float : right"  @click="revokeUser()">Revoke</CButton>
                            
            </template>
        </CModal>
        
        
        <CModal
            v-if="preview!= null"
            title="Change Role"
            size="sm"
            :show.sync="modals.role"
        >
            <CForm>
                <CSelect
                    label="Select a role"
                    :options="rolesOption"
                    :value.sync="newRole"
                />      
            </CForm>
            <template v-slot:footer>
                <CButton type="submit" size="sm" color="danger" style="float : left"    @click="showRoleModal(false)">Cancel</CButton>
                <CButton type="submit" size="sm" color="success" style="float : right"  @click="changeRole()">Change</CButton>
                            
            </template>
        </CModal>


        <CModal
            v-if="preview != null"
            title="Change Zone"
            size="sm"
            :show.sync="modals.zone"
        >
            <CForm>
                <CSelect
                    label="Select a zone"
                    :options="zones"
                    :value.sync="newZone"
                />      
            </CForm>
            <template v-slot:footer>
                <CButton type="submit" size="sm" color="danger" style="float : left"    @click="showZoneModal(false)">Cancel</CButton>
                <CButton type="submit" size="sm" color="success" style="float : right"  @click="changeZone()">Change</CButton>
                            
            </template>
        </CModal>

        <CModal
            v-if="preview.show"
            title="Approve a user"
            size="xl"
            :show.sync="modals.approveUser"
        >
            <CRow class="mb-1">
                <CCol md="6">
                    <strong>User : </strong>{{this.preview.name}}           <br>      
                    <strong>Designation : </strong>{{this.preview.role}}    <br>           
                    <span v-if="this.preview.assignedZone != null"><strong>Assigned Zone : </strong>{{this.preview.assignedZone.name}}</span>
                    <span v-else><strong>Assigned Zone : </strong><i>Not yet assigned!</i></span>
                </CCol>
                <CCol md="6">
                    <CCard>
                        <CCardHeader class="text-center">
                            <strong>Available Zones</strong>     
                        </CCardHeader>
                        <CCardBody style="max-height :370px; overflow-y : scroll">
                            <CSelect
                                label="Select a role"
                                :options="rolesOption"
                                :value.sync="preview.role"
                            />
                            <CSelect
                                label="Select a zone"
                                :options="zones"
                                :value.sync="newZone"
                            />                           
                        </CCardBody>
                    </CCard>
                </CCol>
            </CRow>
            <template v-slot:footer>
                <pulse-loader :loading="loading" color="#2E7D32"></pulse-loader>
                <CButton type="submit" size="sm" color="danger" style="float : left"    @click="showApproveUserModal(false)">Cancel</CButton>
                <CButton type="submit" size="sm" color="success" style="float : right"  @click="approveUser()">Approve User</CButton>
                            
            </template>
        </CModal>
        <CModal
            title="Create New User"
            size="lg"
            :show.sync="modals.createUser"
        >
            <CForm>
                <CRow>
                    <CCol sm="6">
                        <CInput label="First Name" v-model="newUser.firstname" placeholder="Enter first name"/>
                    </CCol>
                    <CCol sm="6">
                        <CInput label="Last Name" v-model="newUser.lastname" placeholder="Enter last name"/>
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <CInput label="Email" v-model="newUser.email" placeholder="Enter email"/>
                    </CCol>
                    <CCol sm="6">
                        <CInput label="Phone" v-model="newUser.phone" placeholder="Enter phone number"/>
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <CInput label="Password" type="password" v-model="newUser.password" placeholder="Enter password"/>
                    </CCol>
                    <CCol sm="6">
                        <CSelect label="Role" :options="rolesOption" :value.sync="newUser.role"/>
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="12">
                        <CSelect label="Zone" :options="zones" :value.sync="newUser.assignedZone"/>
                    </CCol>
                </CRow>
            </CForm>
            <template v-slot:footer>
                <CButton color="danger" @click="showCreateUserModal(false)">Cancel</CButton>
                <CButton color="success" @click="createUser()">Create User</CButton>
            </template>
        </CModal>
    </div>
</template>

<script>
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import axios from 'axios';
import store from '../store';
import JsonExcel from 'vue-json-excel';

export default {
    name : 'Users',
    components: {
        PulseLoader,
        JsonExcel
    },
    props : {
        small : true,
        
    },
    data() {
        return {
            baseURL : store.state.baseURL,
            items: [
            ],
            searchText : '',
            perPage: 12,
            currentPage: 1,
            tableLength : 0,
            loading : true,
            fields : [
                { key: 'user' },
                { key: 'assignedZone', label : 'Zone', _classes: 'text-center' },
                { key: 'role', _classes: 'text-center' },
                { key: 'activity', _classes: 'text-center' }
            ],
            preview : {
                show : false,
                userid : '',
                name : '',
                phone : '',
                email : '',
                role : '',
                assignedZone : '',
                _isAdminVerified : '',
                _isRevoked : '',
                _createdAt : ''
            },
            roles : {
                "Admin" : "Admin", 
                "subadmin" : "Sub Admin",
                "Editor" : "Editor", 
                "Viewer" : "Viewer", 
                "Mobile-User" : "Mobile User"
            },
            rolesOption : [
                { value : "Admin", label: "Admin"},
                { value : "subadmin", label: "Sub Admin"},
                { value : "Editor", label: "Editor"},
                { value : "Viewer", label: "Viewer"},
                { value : "Mobile-User", label: "Mobile User"}
            ],
            zones : [],
            modals : {
                revoke : false,
                role : false,
                approveUser : false,
                zone : false,
                createUser : false
            },
            revoke : {
                reason : '',
                userid : '',
                value : ''
            },
            newUser : {
                firstname : '',
                lastname : '',
                email : '',
                phone : '',
                password : '',
                role : 'Mobile-User',
                assignedZone : ''
            },
            newRole : '',
            newZone : '',
            
        }
    },
    created() {
        this.getRecords();
        this.getZones();
    },
    watch: {
        currentPage : {
            handler: function() {
                this.getRecords(this.currentPage);
            }
        }
    },
    methods: {
        showRoleModal(d){
            if(!d)
                this.newRole = '';
            this.modals.role = d;

        },
        showZoneModal(d){
            if(!d)
                this.newZone = null;
            this.modals.zone = d;

        },
        showApproveUserModal(d){
            this.modals.approveUser = d;
        },
        showCreateUserModal(d){
            if(!d){
                this.newUser = {
                    firstname : '',
                    lastname : '',
                    email : '',
                    phone : '',
                    password : '',
                    role : 'Mobile-User',
                    assignedZone : ''
                }
            }
            this.modals.createUser = d;
        },
        showAreaModal(d){
            this.modals.area = d;
        },
        showRevokeModal(v){
            if(v == null){
                // Cancelled — restore original revoke state
                this.preview._isRevoked = this.revoke._originalValue;
                this.revoke = {
                    reason : '',
                    userid : '',
                    value : '',
                    _originalValue : false
                }
                this.modals.revoke = false;
            }
            else{
                this.revoke = {
                    reason : '',
                    userid : v.tag,
                    value : v.value,
                    _originalValue : !v.value  // store the value BEFORE the toggle changed
                }
                this.modals.revoke = true;
            }
        },
        changeRole(){
            if(this.newRole != this.preview.role){
                axios({
                    url : this.baseURL + "admin/changeRole",
                    headers : {
                        authorization : store.state.token
                    },
                    method : "POST",
                    data : {
                        'userid' : this.preview.userid,
                        'role' : this.newRole
                    }
                })
                .then(res => {
                    this.loading = false;
                    if(res.data.status)
                    {                    
                        this.$notify({
                            group: 'notification',
                            type : 'success',
                            title: 'Important message',
                            text: 'Successfully changed role'
                        });          

                        this.closePreview();
                        this.showRoleModal(false)
                        this.getRecords(); 
                    }
                    else
                    {
                        this.$notify({
                            group: 'notification',
                            type : 'error',
                            title: 'Important message',
                            text: res.data.message
                        });
                    }
                })
                .catch(err => {
                    this.$notify({
                        group: 'notification',
                        type : 'error',
                        title: 'Important message',
                        text: 'Error in loading data. Something went wrong!'
                    });
                    console.log(err);
                    
                });

            }
            else{
                this.showRoleModal(false);
            }
        },
        changeZone(){
            let zone = '';
            if(this.preview.assignedZone){
                zone = this.preview.assignedZone.name;
            }
            if(this.newZone != zone && !(this.newZone == null || this.newZone == '')){
                axios({
                    url : this.baseURL + "admin/changeZone",
                    headers : {
                        authorization : store.state.token
                    },
                    method : "POST",
                    data : {
                        'userid' : this.preview.userid,
                        'zoneId' : this.newZone
                    }
                })
                .then(res => {
                    this.loading = false;
                    if(res.data.status)
                    {                    
                        this.$notify({
                            group: 'notification',
                            type : 'success',
                            title: 'Important message',
                            text: 'Successfully changed zone for selected user'
                        });          

                        this.closePreview();
                        this.showZoneModal(false);
                        this.getRecords(); 
                    }
                    else
                    {
                        this.$notify({
                            group: 'notification',
                            type : 'error',
                            title: 'Important message',
                            text: res.data.message
                        });
                    }
                })
                .catch(err => {
                    this.$notify({
                        group: 'notification',
                        type : 'error',
                        title: 'Important message',
                        text: err.response.data.message
                    });
                    console.log(err);
                    
                });

            }
            else{
                this.$notify({
                    group: 'notification',
                    type : 'warn',
                    title: 'Cannot process empty request!',
                    text: 'Please select a new zone to proceed!'
                });
                this.showRoleModal(false);
            }
        },
        toggleAccountStatus(value){
            axios({
                url : this.baseURL + "user/toggle-account-status",
                headers : {
                    authorization : store.state.token
                },
                method : "POST",
                data : {
                    'userid' : this.preview.userid,
                    'status' : value.value
                }
            })
            .then(res => {
                this.loading = false;
                if(res.data.status)
                {                    
                    this.$notify({
                        group: 'notification',
                        type : 'success',
                        title: 'Success',
                        text: res.data.message
                    });          
                    this.closePreview();
                    this.getRecords();
                }
                else
                {
                    this.$notify({
                        group: 'notification',
                        type : 'error',
                        title: 'Error',
                        text: res.data.message
                    });
                }
            })
            .catch(err => {
                this.loading = false;
                this.$notify({ group: 'notification', type : 'error', title: 'Error', text: err.response.data.message || 'Something went wrong!' });
            });
        },
        revokeUser(value){
            axios({
                url : this.baseURL + "admin/revoke",
                headers : {
                    authorization : store.state.token
                },
                method : "POST",
                data : {
                    'userid' : this.revoke.userid,
                    'revoke' : this.revoke.value.toString(),
                    'reason' : this.revoke.reason == '' ? "Unknown. Please contact admin for more!" : this.revoke.reason
                }
            })
            .then(res => {
                this.loading = false;
                if(res.data.status)
                {                    
                    this.$notify({
                        group: 'notification',
                        type : 'success',
                        title: 'Important message',
                        text: 'Successfully revoked'
                    });          
                    this.showRevokeModal(null);
                    this.getRecords();
                }
                else
                {
                    this.$notify({
                        group: 'notification',
                        type : 'error',
                        title: 'Important message',
                        text: res.data.message
                    });
                    this.preview._isRevoked = false;
                }
            })
            .catch(err => {
                this.$notify({
                    group: 'notification',
                    type : 'error',
                    title: 'Important message',
                    text: 'Something went wrong!'
                });
                console.log(err);
                this.preview._isRevoked = false;
                
            });
        },
        createUser(){
            if(!this.newUser.firstname || !this.newUser.phone || !this.newUser.password){
                return this.$notify({ group: 'notification', type: 'error', title: 'Error', text: 'Please fill name, phone and password!' });
            }
            this.loading = true;
            axios({
                url : this.baseURL + "admin/createUser",
                headers : { authorization : store.state.token },
                method : "POST",
                data : this.newUser
            })
            .then(res => {
                this.loading = false;
                if(res.data.status){
                    this.$notify({ group: 'notification', type : 'success', title: 'Success', text: 'Successfully created user' });
                    this.showCreateUserModal(false);
                    this.getRecords();
                } else {
                    this.$notify({ group: 'notification', type : 'error', title: 'Error', text: res.data.message });
                }
            })
            .catch(err => {
                this.loading = false;
                this.$notify({ group: 'notification', type : 'error', title: 'Error', text: err.response.data.message || 'Something went wrong!' });
            });
        },
        approveUser(){
            if( this.modals.approveUser == true ){
                if(confirm("Do you want to verify this user? This action cannot be undone!")){
                    axios({
                        url : this.baseURL + "admin/approveUser",
                        headers : {
                            authorization : store.state.token
                        },
                        method : "POST",
                        data : {
                            'userid' : this.preview.userid,
                            'role' : this.preview.role,
                            'zoneId' : this.newZone
                        }
                    })
                    .then(res => {
                        this.loading = false;
                        if(res.data.status)
                        {                    
                            this.$notify({
                                group: 'notification',
                                type : 'success',
                                title: 'Important message',
                                text: 'Successfully verified'
                            });          

                            this.modals.approveUser = false;
                            this.modals.area = false;
                            this.closePreview();
                            this.getRecords();
                        }
                        else
                        {
                            this.$notify({
                                group: 'notification',
                                type : 'error',
                                title: 'Important message',
                                text: res.data.message
                            });
                            this.modals.approveUser = false;
                            this.modals.area = false;
                            this.preview._isAdminVerified = false;
                        }
                    })
                    .catch(err => {
                        this.$notify({
                            group: 'notification',
                            type : 'error',
                            title: 'Important message',
                            text: 'Error in loading data. Something went wrong!'
                        });
                        console.log(err);
                        this.modals.approveUser = false;
                        this.modals.area = false;
                        this.preview._isAdminVerified = false;
                        
                    });
                }
                else{
                    this.preview._isAdminVerified = false;
                }
            }
            else{
                this.newZone = this.preview.assignedZone ? this.preview.assignedZone._id : null;
                this.preview._isAdminVerified = false;
                this.modals.approveUser = true;
            }
            

        },
        closePreview(){
            this.preview = {
                show : false,
                userid : '',
                name : '',
                phone : '',
                email : '',
                role : '',
                assignedZone : '',
                _isAdminVerified : '',
                _isRevoked : '',
                _isAccountActive : true,
                _createdAt : ''

            }
        },
        getRecords(page){
            if(!page)
                this.currentPage = 1;
            
            this.loading = true;
            axios({
                url : this.baseURL + "admin/allUsers",
                headers : {
                    authorization : store.state.token
                },
                method : "POST",
                data : {
                    'search' : this.searchText,
                    'page' : this.currentPage,
                    'limit' : this.perPage,
                    'isDeleted' : true
                }
            })
            .then(res => {
                this.loading = false;
                if(res.data.status)
                {                    
                    this.items = res.data.data.items;
                    this.tableLength = res.data.data.totalCount;          
                }
                else
                {
                    this.items = []
                    this.tableLength = 0;
                    this.$notify({
                        group: 'notification',
                        type : 'error',
                        title: 'Important message',
                        text: res.data.message
                    });
                }
            })
            .catch(err => {
                if(err.response.status == 404)
                {
                    this.$notify({
                        group: 'notification',
                        type : 'warn',
                        title: 'Important message',
                        text: 'No results found!'
                    });
                }
                else{
                    this.$notify({
                        group: 'notification',
                        type : 'error',
                        title: 'Important message',
                        text: 'Error in loading data. Something went wrong!'
                    });
                    console.log(err);
                    
                }
                this.items = []
                this.tableLength = 0;
                this.loading = false;
                return [];
                
            });

        },
        getZones(){
            this.loading = true;
            axios({
                url : this.baseURL + "zones/all",
                headers : {
                    authorization : store.state.token
                },
                method : "GET",
            })
            .then(res => {
                this.loading = false;
                if(res.data.status)
                {                    
                    let tempZones = res.data.data;

                    this.zones = tempZones.map(item => {
                        return {
                            value : item._id,
                            label : item.name.toUpperCase()
                        }
                    });       
                }
                else
                {
                    this.zones = []
                    this.$notify({
                        group: 'notification',
                        type : 'error',
                        title: 'Important message',
                        text: res.data.message
                    });
                }
            })
            .catch(err => {
                if(err.response.status == 404)
                {
                    this.$notify({
                        group: 'notification',
                        type : 'warn',
                        title: 'Important message',
                        text: 'No results found!'
                    });              
                }
                else{
                    this.$notify({
                        group: 'notification',
                        type : 'error',
                        title: 'Important message',
                        text: 'Error in loading data. Something went wrong!'
                    });
                    console.log(err);
                    
                }
                this.zones = []
                this.loading = false;
                return [];
                
            });

        },
        onSelectRow(row){
            this.preview = {
                userid : '',
                name : '',
                phone : '',
                email : '',
                role : '',
                assignedZone : '',
                _isAdminVerified : '',
                _isRevoked : '',
                _isAccountActive: true,
                _createdAt : ''

            }
            const data_item = row[0];

            if(data_item != null && data_item != undefined){
                this.preview = {
                    show : true,
                    userid : data_item._id,
                    name : data_item.name,
                    phone : data_item.phone,
                    email : data_item.email,
                    role : data_item.role,
                    assignedZone : data_item.assignedZone,
                    _isAdminVerified : data_item._isAdminVerified,
                    _isRevoked : data_item._isRevoked,
                    _isAccountActive : data_item._isAccountActive,
                    _createdAt : data_item._createdAt,
                }

                this.newRole = data_item.role
                if(data_item.assignedZone != null){
                    this.newZone = data_item.assignedZone._id;
                }

            }

            

        }

    }
}
</script>

<style scoped>
    .pad-r-0 {
        padding-right: 0px !important;
    }
    .pad-l-0 {
        padding-left: 0px !important;
    }
</style>